// extracted by mini-css-extract-plugin
export default {"root":"Pos-i","control":"RhbjQ","title":"_1S24e"};